import React, { Component } from 'react'
import MyNavbar from "../../components/Navbar/MyNavbar";
import UpdateTicket from '../../components/Ticket/TicketingDetail/UpdateTicket'
export default class UpdateDetailPage extends Component {
    
    render() {
        return (
            <div>
                 <MyNavbar />
                 <UpdateTicket />
            </div>
        )
    }
}
